import { IStackProps, Stack, Icon, IIconProps } from '@fluentui/react';
import { useCallback, useMemo, CSSProperties } from 'react';
import { BORDER } from '../../CONSTANTS';
import { useGridLayoutContext } from '../../context/LayoutContext';
import { RowTitle } from './RowHeader/components/RowTitle';

export const TopTotalHeader = ({ expanded, toggleExpanded }: { expanded: boolean; toggleExpanded: () => void }) => {
    const { rowHeaderSize } = useGridLayoutContext();
    const toggleRowExpanded = useCallback(() => toggleExpanded(), [toggleExpanded]);
    const containerStyles = useMemo((): IStackProps['styles'] => {
        return {
            root: {
                height: '100%',
                overflow: 'hidden',
                paddingRight: 12,
                width: rowHeaderSize,
                left: 0,
                position: 'sticky',
                zIndex: 1,
                backgroundColor: 'inherit',
                borderBottom: BORDER,
                borderRight: BORDER,
            },
        };
    }, [rowHeaderSize]);
    return (
        <Stack horizontal horizontalAlign="space-between" verticalAlign="center" styles={containerStyles}>
            <div style={titleContainerStyle}>
                <Icon styles={expandIconStyles} iconName={expanded ? 'ChevronDown' : 'ChevronRight'} onClick={toggleRowExpanded} />
                <div style={coinContainerStyles}>
                    <RowTitle>Total</RowTitle>
                </div>
            </div>
            <div className="tp-list-capacity-dropzone-overlay tp-grid-top">
                <span className="drop-text">
                    Drop here <Icon iconName="Download" />
                </span>
            </div>
        </Stack>
    );
};

const titleContainerStyle: CSSProperties = {
    paddingLeft: 10,
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    transition: 'background-color .3s',
    gap: 8,
};

const coinContainerStyles: CSSProperties = {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
};
const expandIconStyles: IIconProps['styles'] = { root: { transform: 'scale(0.7)', cursor: 'pointer' } };
